var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wap"},[_c('el-carousel',{attrs:{"height":"80px"}},_vm._l((_vm.data),function(item,index){return _c('el-carousel-item',{key:index},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.url(item.url)}}},[_c('img',{staticClass:"item",attrs:{"src":item.image}})])])}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }